export const pt = {
  selectedLang: 'isso é português',
  Lang: 'Selecione sua lingua',
  AddToBasket: 'Aderir',
  ConfigureYourPack: 'Configurar seu pacote',
  nif: 'NIF',
  account: 'Conta',
  pricingRedSentence:
    '* Apenas um tipo de edição do Trend Micro poderá ser subscrito (sem limite de número de licenças).',
};
